import moment from 'moment'
import React from 'react'
import constant from '../../../constant'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import Paginations from '../../common/paginations'
import ReportActions from '../Report/reportActions'
import DeleteFormAction from '../../common/DeleteFormAction'
import { productionFormReportCodes } from '../../../utils/productionFormReportCodes'

const tableUrlMap = {
    iship_final_delivery_document_check_sheet_submission: constant.Authedcomponent.submitNewBuildingFinalDeliveryDocumentChecksheet.url,
    iship_form_block_inspection_status_submission: constant.Authedcomponent.submitNewBuildingBlockInspectionStatus.url,
    iship_form_new_building_pre_delivery_check_list_submission: constant.Authedcomponent.submitNewBuildingPreDeliveryCheckList.url,
    iship_form_new_building_pre_launching_check_list_submission: constant.Authedcomponent.submitNewBuildingPreLaunchingCheckList.url,
    iship_form_new_building_pre_sea_trial_check_list_submission: constant.Authedcomponent.submitNewBuildingPreSeaTrialCheckList.url,
    iship_weekly_time_sheet_submission: constant.Authedcomponent.submitWeeklyTimesheet.url,
    iship_form_ncr_index_submission: constant.Authedcomponent.submitNewBuildingNCRIndex.url,
    iship_form_daily_inspection_report_submission: constant.Authedcomponent.submitNewBuildingDailyInspectionReport.url,
    iship_confirmation_of_vessel_completion_and_delivery_submission: constant.Authedcomponent.submitNewBuildingConfirmationOfVesselCompletionAndDelivery.url,
    iship_form_ncr_submission: constant.Authedcomponent.submitNewBuildingNCR.url,
};

const List = ({ data, setPage, filterPayload, onDeleted }) => {
    const { submissions, page, limit, total } = data

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table align-middle table-nowrap table-hover">
                                <thead className="table-light">
                                    <tr>
                                        <th scope="col" style={{ width: 70 }}>
                                            ID
                                        </th>
                                        <th scope="col" style={{ width: 70 }}>
                                            REPORTS
                                        </th>
                                        <th scope="col">VESSEL INFORMATION</th>
                                        <th scope="col">DATE CREATED </th>
                                        <th scope="col">DATE SUBMITTED </th>
                                        <th scope="col">STATUS </th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {submissions?.length > 0 ? submissions?.map((item, index) => {
                                        const serialNumber = (page - 1) * limit + index + 1;

                                        return (
                                            <tr key={item.ID || index}>
                                                <td>{serialNumber}</td>
                                                <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                                    {item.FORM_CODE} {item.FORM_NAME}
                                                </td>
                                                <td>
                                                    <p className="text-muted mb-0">
                                                        <span style={{ color: "#ab5858 !important" }}>
                                                            {item.HULL_NUMBER || item.OWNER_NAME} - {item.SHIP_NAME ? item.SHIP_NAME + ' -' : ''} {item.PROJECT_NAME}
                                                        </span>
                                                    </p>

                                                </td>
                                                <td>
                                                    {item.CREATED_ON ? moment(item.CREATED_ON).format('DD-MM-YYYY') : 'NA'}
                                                </td>
                                                <td>
                                                    {item.SUBMISSION_DATE ? moment(item.SUBMISSION_DATE).format('DD-MM-YYYY') : 'NA'}
                                                </td>
                                                <td className={!item.FINAL_SUBMITTED ? 'text-warning' : 'text-success'}>
                                                    {!item.FINAL_SUBMITTED ? 'DRAFT' : 'SUBMITTED'}
                                                </td>


                                                <td>
                                                    <ul className="list-inline font-size-20 contact-links mb-0">
                                                        <li className="list-inline-item px-0">


                                                            <Link
                                                                to={{
                                                                    pathname: tableUrlMap[item.REFERENCE_TABLE] || '/default-path', // Fallback if table not found
                                                                    state: {
                                                                        data: btoa(JSON.stringify(item)),
                                                                        page: page,
                                                                    },
                                                                }}
                                                                title="Edit Form"
                                                            >
                                                                <i className="bx bx-edit" />
                                                            </Link>
                                                        </li>
                                                        {productionFormReportCodes.includes(item.FORM_CODE) ? (
                                                            <ReportActions
                                                                item={item}
                                                                formCode={item.FORM_CODE}
                                                                formName={item.FORM_NAME}
                                                                formId={item.FORM_ID}
                                                            />
                                                        ) : ''}
                                                        <DeleteFormAction
                                                            item={item}
                                                            formCode={item.FORM_CODE}
                                                            formName={item.FORM_NAME}
                                                            formId={item.FORM_ID}
                                                            onDeleted={onDeleted}
                                                        />
                                                    </ul>
                                                </td>
                                            </tr>
                                        )
                                    })
                                        : <tr>
                                            <td colSpan="7" className="text-center text-muted py-3">
                                                No records found.
                                            </td>
                                        </tr>
                                    }

                                </tbody>
                            </table>
                        </div>
                        <Paginations
                            limit={limit}
                            totalCount={total}
                            range={5}
                            currentPage={page}
                            onPageChange={setPage}
                        />

                    </div>
                </div>
            </div>
        </div >

    )
}

export default List
